export default "__VITE_ASSET__VhY_zVdq__"